import React from 'react';
import { useRecordContext, useTranslate } from 'react-admin';

import ChipField from '../../common/fields/ChipField';


const StatusField = ({ source, ...props }) => {
    const record = useRecordContext(props);
    const translate = useTranslate();
    
    const statuses = {
        'draft': translate('Draft'),
        'review': translate('Review'),
        'accepted': translate('Accepted'),
        'refused': translate('Refused')
    };

    if (!record) {
        return null;
    }
    const status = record[source];
    let sx = {};
    switch (status) {
        case 'review':
            sx = { backgroundColor: 'warning.main' };
            break;
        case 'accepted':
            sx = { backgroundColor: 'success.main' };
            break;
        case 'refused':
            sx = { backgroundColor: 'error.main' };
            break;
        default:
            sx = { backgroundColor: '#FFF', border: '1px solid #000' };
            break;
    }

    if (!status) {
        return null;
    }

    return (
        <ChipField {...props} source={status} record={statuses} sx={{ borderRadius: 0, ...sx }} />
    );
};

StatusField.defaultProps = {
    source: 'status',
    size: 'small'
};

export default StatusField;
